import { types, Instance } from 'mobx-state-tree';

const ServiceTemplateCharacteristic = types
	.model('ServiceTemplateCharacteristic', {
		id: types.identifierNumber,
		service_template_id: types.maybeNull(types.number),
		model_type: types.string,
		characteristic: types.string,
		description: types.string,
		default_value: types.string,
	});

export default ServiceTemplateCharacteristic;

export interface IServiceTemplateCharacteristicModel extends Instance<typeof ServiceTemplateCharacteristic> {}
